<section class="site-configurations">
  <iot-platform-ui-panel
    [buttonTooltip]="'SITES.CONFIGURATIONS.ADD' | translate"
    [hasButton]="false"
    [title]="'SITES.CONFIGURATIONS.PANEL_TITLE' | translate"
    [withCustomAction]="true"
    class="mt-4 mb-4"
  >
    @if (thresholdCards && thresholdCards.length > 4) {
      <div
        [matTooltip]="(horizontalLayout ? 'PANELS.TOOLTIPS.HORIZONTAL_LAYOUT' : 'PANELS.TOOLTIPS.VERTICAL_LAYOUT') | translate"
        class="panel-button app-round-button"
        matTooltipClass="regular-tooltip"
        panelCustomAction
      >
        <button (click)="horizontalLayout = !horizontalLayout" fxHide.lt-md mat-icon-button panelCustomAction>
          <mat-icon>{{ horizontalLayout ? 'apps' : 'swap_horiz' }}</mat-icon>
        </button>
      </div>
    }
    <iot-platform-ui-cards-container [horizontalLayout]="horizontalLayout" panelGrid>
      @for (card of thresholdCards; track card) {
        <oyan-ui-threshold-card
          (dispatchEvent)="onDispatchEvent($event)"
          [canUpdate]="canUpdate"
          [element]="card"
          [withMenu]="false"
          class="card-xs"
          fxFlex.lt-md="100%"
        ></oyan-ui-threshold-card>
      }
    </iot-platform-ui-cards-container>
  </iot-platform-ui-panel>
</section>
